import { Button, makeStyles, Text, tokens } from '@fluentui/react-components';
import type { ReactElement, ReactNode } from 'react';

import { spacing } from '@/theme/tokens';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.xxxxl,
    gap: spacing.s,
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
  },
  icon: {
    width: '48px',
    height: '48px',
    color: tokens.colorNeutralForeground3,
  },
});

interface EmptyStateProps {
  icon?: ReactElement;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  children?: ReactNode;
}

export function EmptyState({ icon, title, description, action, children }: EmptyStateProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {icon ? <div className={classes.icon}>{icon}</div> : null}
      <Text size={500} weight="semibold" style={{ color: tokens.colorNeutralForeground1 }}>
        {title}
      </Text>
      {description ? <Text size={300}>{description}</Text> : null}
      {action ? (
        <Button appearance="primary" onClick={action.onClick}>
          {action.label}
        </Button>
      ) : null}
      {children}
    </div>
  );
}
